<template>
	<AspectTableSingleComponents
		:editMode="true"
		:aspectData="aspectData"
		v-if="!preloaderVisibility"
	/>
	<PreloaderComponent
		v-else
	/>
</template>

<script>
import SolFileAPIInstance from '@/api'

import PreloaderComponent from '@/components/common/PreloaderComponent'
import AspectTableSingleComponents from './AspectTableSingleComponents/AspectTableSingleComponents'
export default {
	name: "AspectTableSingleEdit",
	data() {
		return {
			aspectData: {},
			preloaderVisibility: true
		}
	},
	components: {
		PreloaderComponent,
		AspectTableSingleComponents
	},
	mounted() {
		this.fetchSingleAspectInterpretation()
	},

	methods: {
		async fetchSingleAspectInterpretation() {
      const response = await SolFileAPIInstance.getAspectInterpretationById(this.$route.params.id)
      this.preloaderVisibility = false
      this.aspectData = response.data
		}
	}
}
</script>

<style scoped>

</style>